// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d41c79ce","455":"ecbf85ed","977":"b8e5b647"}[chunkId] + ".chunk.js";
};